export const REMOVE_CODES: { [key: string]: string } = {
  "01": "Type 1 Reassignment - Direct Conflict",
  "02": "Type 2 Reassignment",
  "03": "Type 3 Reassignment",
  "04": "Type 4 Reassignment",
  "05": "Type 5 Replacement Flying - Substitution of Equipment",
  "0D": "Captain Upgrade",
  "0I": "Initial training",
  "0N": "International Training",
  "0O": "Other Training",
  "0P": "Proficiency extension",
  "0Q": "Requalification",
  "0R": "Recurrent",
  "0T": "Transition Training",
  "0U": "Upgrade Training",
  "0V": "Observation Ride",
  "11": "FAR 117.11 Removal - Exceedance of maximum flight time per FDP",
  "13": "Miscellaneous Paid Removal Full pay and credit",
  "15": "Miscellaneous Unpaid Removal Unpaid, uncredited",
  "17": "FAR 117.17 Removal - Exceedance of maximum FDP for augmented crew",
  "19": "FAR 117.19 Removal - Flight duty extension illegality",
  "1I": "Initial Remedial Training",
  "1R": "1 Day Recurrent Training",
  "1T": "Transitional remedial training",
  "1U": "Upgrade remedial training",
  "24": "Training Day Off TRFF in HI1 SEQ column",
  "25": "FAR 117.25 Removal Lack of FAR 117 rest",
  "27": "FAR 117.27 Removal",
  "2I": "Initial Training",
  "2N": "International Training",
  "2Q": "Requalification Training",
  "2R": "Recurrent Training",
  "2T": "Transition Training",
  "2U": "Upgrade Training",
  "3B": "FAR 117.23B Removal - Exceedance of max flight hours",
  "3C": "FAR 117.23C Removal - Exceedance of maximum FDP",
  "4C": "Illegality Created by RO",
  "48": "Training Day Off",
  "5B": "FAR 117.25B Removal - Illegal for 30/168 rest",
  "6B": "PVD Buy Back",
  "6G": "Intermittent Military Family Leave",
  "6M": "Intermittent Family Leave",
  "70": "Temporary Flight Supervisor",
  "72": "Temporary CA",
  "7D": "FAR 117 30/168 break",
  "7N": "Full Sequence Removal",
  "85": "Security Training",
  AA: "Appendix A Deadhead Used for a pilot released to deadhead home earlier than legally scheduled",
  AE: "Awaiting OE",
  AF: "Reassignment / Added Flying",
  AI: "Awaiting IOE Or Other Flight Standards Training",
  AK: "Awaiting Line Check",
  AL: "Union Leave - Unpaid",
  AN: "Awaiting International",
  AQ: "Awaiting Requalification",
  AS: "ASAP Training",
  AT: "Awaiting Training",
  BR: "Bereavement Removal With Pay",
  CD: "CKA Displacement",
  CH: "Changeover Sequence",
  CL: "Administrative Cleanup - Due to scheduling mistake",
  CM: "Commuter Missed Trip",
  CO: "DOTC Conflict",
  CS: "California Sick - Can use up to ½ of annual sick accrual",
  CP: "TTOT CPA Removal",
  CU: "California Unpaid Sick",
  DB: "FAR 117.15 Removal - Un-augmented crew split duty period illegality",
  DC: "Direct Conflict Removal",
  DE: "Deceased",
  DL: "Restricted Duty Leave",
  DM: "Restricted Duty Maternity",
  DO: "Day Off Lineholder Only",
  DP: "Displacement",
  DR: "Restricted Duty",
  DT: "Displacement For IOE",
  EE: "Emergency Off",
  EF: "Early Furlough",
  EM: "Act of God Removal",
  EO: "Employee-requested Off",
  FC: "FAR Limit",
  F6: "Family Leave PVD",
  FL: "Family Leave, Unpaid",
  FM: "Family Leave, Unpaid And Uncredited",
  FR: "Furlough",
  FS: "Family Leave Sick",
  FT: "Fatigued",
  FV: "Family Leave Vacation",
  G6: "Military Family Leave PVD",
  GF: "Military unpaid Family Leave",
  GM: "Intermittent family leave For military family member with illness",
  GO: "Greater of Pick-up With Conflict",
  GV: "Military Family leave Used for other family member",
  HR: "Employee orientation",
  I6: "Intermittent family leave PVD",
  IE: "Initial Operating Experience",
  IF: "Paid Union Leave If Needed",
  IH: "Partial Paid Injury On Duty",
  IP: "Injury On Duty",
  IS: "Intermittent Family Leave Using Sick Paid And Credited",
  IU: "Injury On Duty, Unpaid",
  IV: "Intermittent Family Leave Vacation Paid And Credited",
  JD: "Jury Duty",
  LB: "No Legal Rest Break",
  LC: "Awaiting division",
  LE: "OE removal",
  LF: "Family Leave for self or other",
  LK: "Days Off Desired CKA",
  LP: "Parental Leave",
  LS: "Line Operations Safety Audit",
  LV: "Voluntary Leave",
  M1: "Adoption LV",
  M2: "Maternity Paid Sick",
  M3: "Maternity Unpaid Sick",
  M4: "Maternity Personal LV",
  M6: "Military block family leave PVD",
  MA: "Missed Assignment",
  MC: "Misconnect",
  MD: "Medical Disability",
  MF: "Uncredited Family Leave Intermittent",
  MI: "Medical Indisposition",
  ML: "Military Leave 17 Days Or More",
  MN: "Military Leave 16 Days Or Less",
  MO: "Military Request on Days Off",
  MR: "Military Leave 4 Days Or Less",
  MS: "Maternity Paid Sick",
  MT: "Missed Trip",
  MU: "Make Up Flying",
  MV: "Military PVD",
  MX: "Military Leave More Than 4 Days",
  MY: "Military Leave 17 Days Or More",
  NE: "Refused FAR 117.19 Extension",
  N7: "Sequence level removal code if flying on the follow-on sequence originates on a new day",
  NS: "No Show",
  OE: "Operating Experience Block",
  OI: "New Hire Training",
  OP: "Over Projection Removal Paid",
  OT: "Trip Trade With Open Time",
  OX: "Check Airman Displacement",
  P6: "Personal Vacation Day (PVD)",
  PD: "Consolidation Flying",
  PE: "Personal Emergency",
  PL: "Personal Leave",
  PP: "Reserve Pay Protection",
  PR: "Probationary Review",
  PU: "Paid Union Leave",
  PW: "Withheld from Service - Pay and Credit",
  PX: "Paid Transfer",
  QD: "Need Documents - Passport or Medical",
  QE: "Qualification Expired",
  QI: "Qualification Illegality",
  RA: "Reassignment",
  RD: "Replacement of DFP",
  RE: "Resigned",
  RI: "Recurring Injury on Duty",
  RL: "Released",
  RM: "Unvaccinated Pilot Requires Vaccination",
  RT: "Retired",
  RX: "Sequence removal after the Repair Window has expired",
  S6: "Schoolhouse PVD",
  SA: "Special Assignment",
  SD: "Sequence Drop TTOT",
  SI: "Reserve Sick if Needed",
  SK: "Short Term Sick",
  SL: "Long Term Sick",
  SN: "Schoolhouse unpaid",
  ST: "Original Pilot Who Shared Trip",
  SU: "Suspension",
  SV: "Schoolhouse Paid Vacation",
  T6: "TTOT PVD",
  TC: "Commuter Missed Trip",
  TM: "Missed Trip",
  TO: "Training Day Off",
  TR: "Transitional Reserve Day",
  TT: "Trip Trade",
  TX: "Unpaid Base Transfer",
  U8: "Injury on Duty Seven Days or Less",
  UA: "Personal Leave, Unpaid",
  UI: "Recurring unpaid Injury on Duty",
  UL: "Paid Union Leave",
  UM: "Short Term Maternity Leave",
  UR: "Unable to Report",
  US: "Unpaid Sick",
  V1: "Current Vacation Payout for Disability",
  V2: "Accrued Vacation Payout for Disability",
  V6: "Paid Vacation Day (PVD)",
  VA: "PVD Hurricane",
  VB: "Vacation Bank Pay And Credit",
  VC: "Vacation",
  VG: "Intermittent Military Family Leave",
  VM: "Military block Family Leave Vacation",
  VS: "Vacation Slide",
  VT: "Voluntary Leave of Absence",
  VV: "Intermittent Military Family Leave Vacation",
  W6: "Wings PVD",
  WG: "Wings",
  WP: "Witness",
  WS: "Withheld from service",
  WU: "Witness credited",
  XO: "Long Course Training OE",
  XR: "Cancellation Removal",
};
